<template>
  <div class="home-content-box home-recommendation-box">
    <div class="background-white-box right-box left-top-radius" />
    <div class="home-content-body body-max-container">
      <ul>
        <li>
          <div class="home-content-info">
            <div class="home-content-info-body">
              <div class="title">聽聽他們說</div>
              <div class="subTitle">Other opinoin</div>
              <div class="content">
                <img class="desktop-recommendation" src="../../../assets/img/recommendation/desktop/Raye.png" alt="" />
                <img class="desktop-recommendation" src="../../../assets/img/recommendation/desktop/光良.png" alt="" />
                <img class="mobile-recommendation" src="../../../assets/img/recommendation/mobile/Raye.png" alt="" />
              </div>
            </div>
            <div class="enter-btn" @click="goRecommendation">
              <img src="../../../assets/img/icon-arrow-right.svg" alt />
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>

export default {
  name: "HomeRecommendation",
  data() {
    return {};
  },
  methods: {
    goRecommendation() {
      this.$router.push({ name: "Recommendation" });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
